<template>
  <div>
    <ts-card>
      <div
        class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
      >
        <h4 class="ts-text-sm ts-uppercase">{{ $t('product.copyPrice') }}</h4>
        <ts-modal-close-button />
      </div>
    </ts-card>
    <ts-card-wrapper>
      <ts-loading-banner :loading="loading">
        <form>
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group m-b-10">
                <label class="col-form-label control-label required">{{
                  $t('product.fromBranch')
                }}</label>
                <div>
                  <select
                    v-model.number="model.branch_id"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('branch_id') }"
                  >
                    <option :value="null">{{ $t('Select') }}</option>
                    <option
                      v-for="(branch, index) in branchProfiles"
                      :key="index"
                      :value="branch.branch_id"
                    >
                      {{ branch.branch_name_en }}
                    </option>
                  </select>
                  <div class="invalid-feedback" v-if="errors.has('branch_id')">
                    {{ errors.first('branch_id') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row ts-mt-6">
            <div class="col-sm-12 col-lg-12 col-md-12 text-right">
              <ts-button class="btn-sm" @click.prevent="$emit('close')">{{
                $t('cancel')
              }}</ts-button>
              <ts-button
                color="primary"
                class="ml-2 btn-sm"
                :waiting="saving"
                @click.prevent="copy"
                >{{ $t('copy') }}</ts-button
              >
            </div>
          </div>
        </form>
      </ts-loading-banner>
    </ts-card-wrapper>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
export default {
  props: ['data'],
  name: 'copyPrice',
  data() {
    return {
      branches: [],
      loading: false,
      saving: false,
      errors: new Errors(),
      model: {
        branch_id: null
      }
    }
  },
  computed: {
    branchProfiles() {
      return this.branches.filter(
        b => b.branch_id !== this.$store.state.authUser.default_branch_id
      )
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    ...mapActions('product', ['getBranch']),

    async fetchData() {
      this.loading = true
      await this.getBranch().then(response => {
        this.branches = response.data
      })
      this.loading = false
    },
    copy() {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('product/copyPrice', this.model)
        .then(response => {
          this.$emit('before-close')
          this.$emit('close')
          this.saving = false
          this.$toasted.success(response.message)
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.saving = false
        })
    }
  }
}
</script>
